import { Callback1 } from '@deqo/foundation';
import { ShapeInfo } from 'kld-intersections';
import { Geometry, IntersectResult } from '../../../platform/geom/Geometry';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Physical } from '../entities/Physical';
import { Organizable } from './Organizable';
import { PhysicalPlot, Plot } from './Plot';

export class Pen extends Set<Organizable> implements Organizable {

    public static from(elmts: Iterable<Physical>) {
        return new Pen(Array.from(elmts).map(PhysicalPlot.for));
    }

    public static for(plots: Iterable<Plot>) {
        return new Pen(Array.from(plots));
    }

    public static wrap(pens: Iterable<Pen>) {
        return new Pen(pens);
    }

    public left(): number {
        return this.bounds().left;
    }

    public top(): number {
        return this.bounds().top;
    }

    public width(): number {
        return this.bounds().width;
    }

    public height(): number {
        return this.bounds().height;
    }

    public apply() {
        this.forEach(a => a.apply());
        return this;
    }

    public bounds() {
        const rects = [] as Rect[];
        this.forEach(a => rects.push(a.bounds()));
        return Rect.fromMany(rects);
    }

    public centerize() {
        const { width, height } = this.bounds();
        return this.moveBy(width / -2, height / -2);
    }

    public alignTop() {
        // this.forEach(o => o.moveTo(o.left(), this.top()));
        throw new Error('Not implemented');
    }

    public alignCenter() {
        const tt = this.top();
        const th = this.height();
        this.forEach(o => o.moveTo(o.left(), tt + ((th - o.height()) / 2)));
        return this;
    }

    public alignBottom() {
        throw new Error('Not implemented');
    }

    public justifyLeft() {
        throw new Error('Not implemented');
    }

    public justifyCenter() {
        const tl = this.left();
        const tw = this.width();
        this.forEach(o => o.moveTo(tl + ((tw - o.width()) / 2), o.top()));
        return this;
    }

    public justifyRight() {
        throw new Error('Not implemented');
    }

    public intersects(another: Plot) {
        return !!Geometry.intersect(this, another);
    }

    public intersectPoints(another: Geometry): IntersectResult {
        return Geometry.intersect(this, another);
    }

    public moveBy(x: number, y: number) {
        this.forEach(a => a.moveBy(x, y));
        return this;
    }

    public moveTo(x: number, y: number) {
        const v = Point.vector(this.bounds().topLeft(), [x, y]);
        return this.moveBy(v.x, v.y);
    }

    public scaleBy(factor: Point) {
        if (factor.x === 1 && factor.y === 1) return this;
        return this;

        const origin = this.bounds().center();
        for (const a of this) {
            // const oc = a.bounds().center();
            // const v = Point.vector(origin, oc).multiply(factor);
            // const nc = origin.add(v);
            // const np = nc.add([a.width() / -2, a.height() / -2]);// .add(Point.vector(oc, nc));
            // // DebugOverlay.rect('A', a.bounds(), 'red');
            // // DebugOverlay.point('AC', oc, 'red');
            // a.moveTo(np.x, np.y);
            // // DebugOverlay.rect('B', a.bounds(), 'pink');
            // // DebugOverlay.point('BC', nc, 'blue');


            const v = Point.vector(origin, a.bounds().center());
            const nv = v.multiply(factor);
            const np = origin.add(nv).add([a.width() / -2, a.height() / -2]);
            a.moveTo(np.x, np.y);
        }

        return this;
    }

    public toShapeInfo(): any {
        const { left, top, width, height } = this.bounds();
        return ShapeInfo.rectangle({ left, top, width, height });
    }

    public map<R>(callback: Callback1<R, Organizable>): R[] {
        const arr = [] as R[];
        for (const x of this) {
            arr.push(callback(x));
        }
        return arr;
    }
}
